import { mapState, mapActions } from 'vuex';

import {
  accountsAPI,
} from '@/services';
import { toast } from '@/utils/message';

import { consultExit } from '@/utils/promoterAccess';

export default {
  computed: {
    ...mapState({
      token: (state) => state.app.token,
      $_userInfo: (state) => state.user.userInfo,
    }),
    userInfo: {
      get() {
        return this.$_userInfo;
      },
      set(payload) {
        this.setUserData(payload);
      },
    },
  },
  async mounted() {
    const { name: currentRoute } = this.$router.history.current;
    if (currentRoute !== 'login' && this.token) await this.getUserData();
  },
  methods: {
    ...mapActions({
      setUserData: 'user/SET_USER_DATA',
    }),
    // A push to login here is invisible: with a live session the guard forwards it to
    // the landing screen. Ending a session is the interceptor's job.
    async getUserData() {
      await accountsAPI
        .getInfoUser()
        .then(async ({ data }) => {
          this.userInfo = data;
          this.leaveScreenBlockedInReadOnly();
        })
        .catch(() => {
          toast('Não foi possível carregar seus dados de usuário. Recarregue a página se algo sumir da tela.', 'warning');
        });
    },
    /**
     * The route guard runs before this fetch answers, so a reload straight into an
     * operation screen gets past it with the user still unknown. This is the
     * second gate, once the session is finally known.
     */
    leaveScreenBlockedInReadOnly() {
      const path = consultExit({
        userInfo: this.$_userInfo,
        path: this.$route.path,
        resolvePath: (target) => this.$router.resolve(target).route.path,
      });

      if (path) this.$router.replace({ path }).catch(() => {});
    },
  },
};
